import React from 'react'
import { ContactConfirmationModalProps } from './types'
import { useTranslation } from 'react-i18next'
import Button from "@sharedComponents/Button";

const ContactConfirmationModalContent = (
    props: ContactConfirmationModalProps
) => {
    const { t } = useTranslation()
    return (
        <div className='contact-confirmation-modal-content'>
            <div dangerouslySetInnerHTML={{__html: props.cmsContent || ''}}/>
            <Button
                text={t('button.close')}
                type="primary"
                onClick={props.onClose}
            />
        </div>
    )
}

export default ContactConfirmationModalContent